function setAddressByCep(params) {
    cepFromat = params.cep.replace(/^(\d{5})(\d{3}).*/, "$1-$2");

    $('.content-form-outro-endereco input[name=cep]').val(cepFromat);
    $('.content-form-outro-endereco input[name=endereco]').val(params.logradouro);
    $('.content-form-outro-endereco input[name=cidade]').val(params.cidade);
    $('.content-form-outro-endereco input[name=bairro]').val(params.bairro);
    $('.content-form-outro-endereco select[name=estado]').val(params.estado);
}

// ========================
// Buscar CEP (Outro endereço)
// ========================
$('.m-outro-endereco [name="cep"]').on("input", function () {

    var cep = $('.m-outro-endereco [name="cep"]').val();

    if (cep.length < 9)
        return false;

    var c = cep.replace("-", "");
    var cepUrl = "//api.awsli.com.br/v2/cep?cep=" + c;

    $('.m-outro-endereco #buscacep input[name=buscacep]').attr("disabled", "disabled");

    $.ajax({
        url: cepUrl
    })
        .done(function (response) {
            $('.m-outro-endereco #buscacep #cep').removeAttr("disabled");
            $('.m-box-entrega .content-get-cep').addClass('is-inactive').removeClass('is-active');
            $('.m-box-entrega .content-form-outro-endereco').addClass('is-active').removeClass('is-inactive');

            setAddressByCep({
                "cep": response.cep,
                "logradouro": response.logradouro,
                "cidade": response.cidade,
                "bairro": response.bairro,
                "estado": response.estado
            });
        })
        .fail(function (response) {
            alert(response.statusText);
            $('.m-outro-endereco #buscacep #cep').removeAttr("disabled").val("");
        })

    return false;
});

// ========================
// Cancelar (Outro endereço)
// ========================

$('.m-box-entrega #entregaEndereco .btn-cancel').click(function (event) {
    event.preventDefault();
    $('.m-box-entrega .content-get-cep').removeClass('is-inactive').addClass('is-active');
    $('.m-box-entrega').removeClass('is-active').addClass('is-inactive');
    $('.m-box-entrega #entregaEndereco input, .m-box-entrega #entregaEndereco select, .m-box-entrega .campo-cep input').val("").removeClass('is-err');
    $('.m-box-entrega #entregaEndereco .campo-erros ul li').remove();
});

// ========================
// Validar form (Outro endereço)
// ========================

$('.m-box-entrega form#entregaEndereco').submit(function () {
    var campo = {
        "nome": $("input[name=nome]", this),
        "endereco": $("input[name=endereco]", this),
        "numero": $("input[name=numero]", this),
        "complemento": $("input[name=complemento]", this),
        "cep": $("input[name=cep]", this),
        "bairro": $("input[name=bairro]", this),
        "cidade": $("input[name=cidade]", this),
        "estado": $("select[name=estado] option:checked", this)
    }

    $('.campo-erros ul li', this).remove();
    var erros = [];

    if (campo.nome.val().length < 3) {
        campo.nome.addClass('is-err');
        erros.push("Nome");
    } else {
        campo.nome.removeClass("is-err");
    }

    if (campo.endereco.val().length < 3) {
        campo.endereco.addClass('is-err');
        erros.push("Endereço");
    } else {
        campo.endereco.removeClass("is-err");
    }

    if (campo.numero.val().length == 0) {
        campo.numero.addClass('is-err');
        erros.push("Número");
    } else {
        campo.numero.removeClass("is-err");
    }

    if (campo.cep.val().length < 9) {
        campo.cep.addClass('is-err');
        erros.push("CEP");
    } else {
        campo.cep.removeClass("is-err");
    }

    if (campo.bairro.val().length < 3) {
        campo.bairro.addClass('is-err');
        erros.push("Bairro");
    } else {
        campo.bairro.removeClass("is-err");
    }

    if (campo.cidade.val().length < 2) {
        campo.cidade.addClass('is-err');
        erros.push("Cidade");
    } else {
        campo.cidade.removeClass("is-err");
    }

    if (erros.length !== 0) {
        $.each(erros, function (key, val) {
            $('form#entregaEndereco .campo-erros ul').append("<li>Verifique o campo <strong>\"" + val + "\"</strong>.</li>");
        });
        return false;
    }
});

$("select[name=detido]").change(function (event) {
    if ($(this).val() != '') {
        $(this).parent().next().show();
        $(".btn-continuar").show();
    } else {
        $(this).parent().next().hide();
        $(".btn-continuar").hide();
    }
});

$("input[type=radio][name=detido]").on('click', function () {
    var input = $(this);
    input.prop('checked', !input.data('prev-checked'));
    input.data('prev-checked', input.is(':checked'));
}).each(function () {
    var input = $(this);
    input.data('prev-checked', input.is(':checked'));
});

// $(window).on('init resize', function () {
// 	var isMobile = window.innerWidth <= 780;
// 	$('.page-content.entrega input[name=detido]').prop('disabled', !isMobile);
// 	$('.page-content.entrega select[name=detido]').prop('disabled', isMobile);
// }).trigger('init');

$('.m-box-entrega .content-detido .controls .btn.btn-cancel').click(function (event) {
    event.preventDefault();
    $(".m-unidade-entrega .box-address .controls").removeClass('is-inactive');
    $(".m-unidade-entrega .content-detido").removeClass('is-active').addClass('is-inactive');
    $("form#entrega input[name=entregarUnidade]").val(0);
});

$('.m-box-entrega .content-detido .campo select').change(function () {
    var visitante = '';
    var id_detido = '';

    visitante = $("option:checked", this).attr("data-visitante") || '';
    id_detido = $("option:checked", this).val() || '';

    $(".m-box-entrega .content-detido .show-visitante").html(visitante);
    $("form#entrega input[name=detido_id]").val(id_detido);
});

Entrega = {
    setFrete: function (price) {
        priceFormat = Moeda.formatar(price);

        $("#value-frete").val(price);

        $('.m-finalizar-entrega input[name=precoFrete]').val(price);
        $('.m-finalizar-entrega .total-geral .show-frete').html("R$ " + priceFormat);
        $('.m-box-entrega input[name=precoFrete]').val(price);
        $('.m-box-entrega .total-geral .show-frete').html("R$ " + priceFormat);
        Entrega.calcular();
    },
    calcular: function () {

        var frete = Number($("#value-frete").val());
        var totalParcial = Number($("#value-total").val());

        var result = frete + totalParcial;

        console.log(result)

        $('.m-finalizar-entrega .total-geral .show-preco-total, .value.show-preco-total').html("R$ " + Moeda.formatar(result));
    }
}

$('.m-box-entrega .total-geral input[type=radio][name=frete]').change(function () {
    // var price = $('option:checked', this).attr("data-price");

    var tipo_frete = $(this).val();

    calc_frete(tipo_frete)
});

//$('.m-box-entrega .total-geral input[type=radio][name=frete]').first().click();

$('.m-finalizar-entrega .total-geral input[type=radio][name=frete]').change(function () {
    // var price = $('option:checked', this).attr("data-price");

    var tipo_frete = $(this).val();

    calc_frete(tipo_frete)
}).trigger('change');

function carregar_opcoes_frete() {
    $('.boxFrete').each(function () {
        var $this = this;
        $.ajax({
            url: Utils.path + 'frete/calcula',
            type: 'POST',
            dataType: 'json',
            data: {
                tipo_frete: $($this).find('input').val()
            },
            success: function (data) {

                if (data.err) {
                    $($this).hide();
                } else {
                    $($this).show();

                    var prazo = typeof data.msg.prazo == "object" ? data.msg.prazo[0] : data.msg.prazo;
                    $($this).find('b').text("R$ " + data.msg.valor.toFixed(2).replace('.', ',') + " - " + prazo + " dias úteis");
                }
            }
        })
    });
}

jQuery(document).ready(function ($) {

    $('#entregaDetido').parent().find("a").trigger("click").trigger("change");

    const loading = new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, 2000);


    });

    loading.then(function () {

        carregar_opcoes_frete();

        if ($("#entregar_na_unidade").length) {
            if ($("#entregar_na_unidade").val() == 1) {
                if ($("#tem_dia_sedex").val() == 1)
                    calc_frete(2);
                else
                    calc_frete(1);
            } else {
                calc_frete(1);
            }
        }

        $('#entregaDetido').parent().find("a").click(function () {
            carregar_opcoes_frete();
        });

        $("#entregaEndereco button").click(function () {
            carregar_opcoes_frete();
        });

        $('input[name="frete"]').first().trigger("click");
        $('input[name="frete"]').first().trigger("change");
    });


});

function calc_frete(tipo_frete) {
    $(".loading-modal, .img-loading-modal").fadeIn('slow');

    if (tipo_frete > 0) {
        $.ajax({
            url: Utils.path + 'frete/calcula',
            type: 'POST',
            dataType: 'json',
            data: {
                tipo_frete: tipo_frete
            },
        }).done(function (dt) {

            if (dt.err == 0) {
                Entrega.setFrete(dt.msg.valor);

                console.debug(tipo_frete, dt);
                carregar_opcoes_frete();

                $('input[name="frete"]').each(function (i, e) {

                    if ($(e).val() == tipo_frete) {

                        console.log(tipo_frete)

                        var prazo = typeof dt.msg.prazo == "object" ? dt.msg.prazo[0] : dt.msg.prazo;
                        let tipoSedex = tipo_frete > 0 && tipo_frete == 1 ? "" : 10;

                        $(e).next().text("Sedex "+tipoSedex+" - R$ " + dt.msg.valor.toFixed(2).replace('.', ',') + " - " + prazo + " dias úteis");
                    }
                });
            }

            else {
                $("input[name=precoFrete]").val('0');
                Entrega.setFrete(0);

                // if (dt.msg != '')
                //     alert(dt.msg);
            }

            $(".loading-modal, .img-loading-modal").fadeOut('slow');
        })
            .fail(function () {
                Entrega.setFrete(0);
                // alert('Ocorreu um erro ao calcular o frete!\nTente novamente mais tarde!');

                $(".loading-modal, .img-loading-modal").fadeOut('slow');
            });
    }

    else {
        Entrega.setFrete(0);
        $(".loading-modal, .img-loading-modal").fadeOut('slow');
    }
}


$('form#entrega').submit(function () {
    var noTerms = !$('input[name=termosdeuso]').is(":checked");

    if (noTerms && !$('.entrega-index').length) {
        alert("É preciso marcar \"Li e Concordo com os Termos de Uso\"")
        return false;
    }
});


if ($('.entrega-index').length) {

    $('.boxFrete input:checked').click();

    $('.boxFrete input').on('change click', function () {
        var timeCookie = new Date().setHours(23, 59, 59, 0)
        document.cookie = "frete=" + $(this).val() + "; expires=" + new Date(timeCookie).toUTCString() + ";";
        var $form = $(this).closest('form');
        $.ajax({
            url: $form.attr('action'),
            method: "POST",
            data: $form.serialize(),
            success: function () {
                console.log("Frete alterado");
            }
        })
    });

    $('.m-unidade-entrega').find('> a').click(function (e) {
        e.preventDefault();
        var form = $('#entregaDetido');
        $.ajax({
            url: form.attr('action'),
            method: "POST",
            data: form.serialize(),
            success: function (data) {

                if ($("#tem_dia_sedex").val() == 1)
                    calc_frete(2);
                else
                    calc_frete(1);
            }
        });
    });

    $('.m-outro-endereco').find('[type="submit"]').click(function (e) {
        e.preventDefault();
        var form = $('#entregaEndereco');
        $.ajax({
            url: form.attr('action'),
            method: "POST",
            data: form.serialize(),
            success: function (data) {

                form.find('[type="submit"]').text("Endereço Salvo");
                calc_frete(1);
            }
        });
    });

    $('.btn-continuar.ajax-btn').click(function () {
        if (!$('[name="frete"]:checked').length) {
            alert("Selecione uma forma de frete");
            return false;
        }

        if (!$('#termosdeuso:checked').length) {
            alert("Você precisa aceitar os termos de uso");
            return false;
        }

        if (!$('.choose-btn.checked').length) {
            alert("Selecione uma forma de entrega");
            return false;
        }

        if ($('.choose-btn.checked [type="submit"]').length && $('.choose-btn.checked [type="submit"]').text().trim() !== "Endereço Salvo") {
            alert("Prencha todos os campos de endereço e selecione 'Salvar Endereço'");
            return false;
        }

        $('.choose-btn.checked').parent().find('form').submit();


    });
}

$(document).ready(function () {
    $('#entregaDetido [type="radio"]').click(function (e) {
        e.preventDefault();
        if ($('[type="radio"]:checked').length) {
            $('#entregaDetido').submit();
        }
    });
});


var formEntrega = $('.page-content.entrega form#entrega');
var action = formEntrega.attr('action');
$(window).on('resize init', function () {
    formEntrega.attr('action', action + (window.innerWidth <= 780 ? '?mobi=1' : ''));
}).trigger('init');
